import React, { useEffect, useRef, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { Col, Row, Spin } from 'antd';
import { useCookies } from 'react-cookie';
import VisibilitySensor from 'react-visibility-sensor';

import AccountNav from '../../components/AccountNav/AccountNav';
import AccountNavMobile from '../../components/AccountNavMobile/AccountNavMobile';
import MarketBreadcrumb from '../../components/MarketBreadcrumb/MarketBreadcrumb';
import MarketFooter from '../../components/MarketFooter/MarketFooter';
import MarketSliderCard from '../../components/MarketSliderCard/MarketSliderCard';
import NoSearchResult from '../../components/NoSearchResult/NoSearchResult';
import NotifyMeModal from '../../components/NotifyMeModal/NotifyMeModal';
import OpenPop from '../../components/OpenPop/OpenPop';
import QuickBuyInitial from '../../components/QuickBuyInitialOffering/QuickBuyInitial';
import QuickBuyInitialDrawer from '../../components/QuickBuyInitialOffering/QuickBuyInitialDrawer';
import SearchFilter from '../../components/SearchFilter/SearchFilter';

import { Images } from '../../config/images';

import useFilters from '../../Hooks/useFilters';
import useMediaQuery from '../../Hooks/useMediaQuery';
import useQuickBuyOrder from '../../Hooks/useQuickBuyOrder';
import { updateFavoriteCount } from '../../store/reducer/favoriteSlice';
import {
  addOrRemoveToFavouriteAction,
  fetchInitialOfferingListAction,
  updateWebInitialPropertyList,
} from '../../store/reducer/initialOfferingSlice';
import { notifyMeForProperty } from '../../store/reducer/notifyMeSlice';
import { maxShareCalculatorWithNoOfShare } from '../../utils/maxShareCalculator';

import './MarketPlace.scss';
import { GHOST_NOTIFY, PRIMARY_BUTTON_BUY, PRIMARY_PROPERTY_LABELS } from '../../utils/constant';

const MarketplaceInitial = () => {
  const [openQuickBuy, setOpenQuickBuy] = useState('');
  const [, setmobilePage] = useState(1);
  const [quickBuyPropertyData, setQuickBuyPropertyData] = useState();
  const [cookies, setCookie] = useCookies(['intialHeaderMessage']);
  const [newsLetterChecked, setNewsLetterChecked] = useState(false);
  const [storeNotifyMeData, setStoreNotifyMeData] = useState({});
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [notifyLoadingId, setNotifyLoadingId] = useState(0);

  const screenMD = useMediaQuery('(min-width: 1000px)');
  const shouldLog = useRef(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const formRef = useRef();
  const quickByOptions = useQuickBuyOrder(setOpenQuickBuy, quickBuyPropertyData);
  const filterOptions = useFilters(setmobilePage);

  const propertyListWebData = useSelector((state) => state.initialOffering.webData);
  const userProfileData = useSelector((state) => state.userData.userData);
  const loading = useSelector((state) => state.initialOffering.loading);
  const loadingMore = useSelector((state) => state.initialOffering.loadingMore);
  const filterApply = useSelector((state) => state.filters.filterApply);

  useEffect(() => {
    if (shouldLog.current) {
      shouldLog.current = false;
      featchInitialOfferingData();
    }
  }, []);

  const onFetchFail = () => {
    if (location?.state?.prevPath) {
      navigate(location.state.prevPath);
    }
    navigate(`/`);
  };

  const featchInitialOfferingData = async (page = 1) => {
    await dispatch(
      fetchInitialOfferingListAction({
        page: 1,
        perPage: 10,
        sortType: 'Newest',
        onFail: onFetchFail,
      })
    );
  };

  const handleNotifyMe = async (value) => {
    setNotifyLoadingId(value?.id);
    await dispatch(
      notifyMeForProperty(
        Object.keys(userProfileData).length
          ? {
              propertyId: value?.id,
              forSecondary: value?.isSecondary,
              onSuccess: () => {
                setOpen(false);
                setEmail('');
                setNotifyLoadingId(0);
                setNewsLetterChecked(false);
                formRef?.current?.resetFields();
              },
            }
          : {
              propertyId: storeNotifyMeData?.id,
              forSecondary: storeNotifyMeData?.isSecondary,
              signUpForNewsletter: newsLetterChecked,
              email: value.email,
              onSuccess: () => {
                setOpen(false);
                setEmail('');
                setNotifyLoadingId(0);
                setNewsLetterChecked(false);
                formRef?.current?.resetFields();
              },
            }
      )
    );
  };

  const onFavouriteFailInitialWeb = async (id) => {
    let updatedArray = propertyListWebData?.data?.properties?.map((item) => (item?.id === id ? { ...item, likedByUser: item?.likedByUser } : item));
    const newData = {
      ...propertyListWebData,
      data: {
        ...propertyListWebData?.data,
        properties: updatedArray,
      },
    };
    await dispatch(updateWebInitialPropertyList({ ...newData }));
  };

  const handleOnFavoriteClickWeb = async (propertyId) => {
    if (Object.keys(userProfileData).length > 0) {
      let updatedArray = propertyListWebData?.data?.properties?.map((item) => {
        if (item?.id === propertyId) {
          if (!item?.likedByUser) {
            dispatch(updateFavoriteCount());
          }
        }
        return item?.id === propertyId ? { ...item, likedByUser: !item?.likedByUser } : item;
      });
      const newData = {
        ...propertyListWebData,
        data: {
          ...propertyListWebData?.data,
          properties: updatedArray,
        },
      };
      await dispatch(updateWebInitialPropertyList({ ...newData }));
      await dispatch(addOrRemoveToFavouriteAction({ propertyId, onFail: (id) => onFavouriteFailInitialWeb(id) }));
    } else {
      navigate('/login');
    }
  };
  return (
    <div className='marketplace marketplaceinitial'>
      {screenMD ? (
        <QuickBuyInitial
          quickBuyPropertyData={quickBuyPropertyData}
          open={openQuickBuy}
          modalState={setOpenQuickBuy}
          quickByOptions={quickByOptions}
          featchData={() => filterOptions?.handleNextPage(false,filterOptions.currentPage)}
        />
      ) : (
        <QuickBuyInitialDrawer
          quickBuyPropertyData={quickBuyPropertyData}
          open={openQuickBuy}
          modalState={setOpenQuickBuy}
          quickByOptions={quickByOptions}
          featchData={() => filterOptions?.handleNextPage(false, 1)}
        />
      )}
      <AccountNav />
      <AccountNavMobile />
      <Spin spinning={loading || loadingMore} wrapperClassName={(loading || loadingMore) && 'ant-spin--fullscreen'} className={(loading || loadingMore) && 'ant-spin--fullscreen'}>
        <MarketBreadcrumb
          filterApply={filterApply}
          propertyListWebData={propertyListWebData}
          title='Invest'
          market='Initial Offerings'
          link={localStorage.getItem('access_token') ? '/marketplace/secondary' : null}
          linkText='Explore Realbricks Market'
        />
        {!(!filterApply && propertyListWebData?.data?.count <= 0) && (
          <SearchFilter
            page='Initial Offerings'
            totalProperties={propertyListWebData?.data?.count ?? 0}
            apiIsSecondary={false}
            filterOptions={filterOptions}
          />
        )}
        {cookies.intialHeaderMessage !== 'true' && (
          <OpenPop
            title='Acquire Shares in Curated and Vetted Rental Properties to Build Your Portfolio.'
            description='Select from our handpicked and meticulously curated residential properties on the Realbricks marketplace. Our properties are chosen for their location in relatively stable residential real estate markets and their potential for growth. Choose a property, purchase shares, and build your portfolio—one brick at a time.'
            art={Images.openpopart}
            onClose={() =>
              setCookie('intialHeaderMessage', true, {
                path: '/marketplace/initial',
              })
            }
          />
        )}
        <div className='initial-offer-wrapper'>
          {propertyListWebData?.data?.properties?.length > 0 && (
            <div className='container-fluid'>
              <Row gutter={[32, 32]}>
                {propertyListWebData?.data?.properties.map((item, index) => (
                  <Col key={item.id} span={24} sm={12} md={8}>
                    <MarketSliderCard
                      id={item?.id}
                      label={item?.label}
                      multiFamilyTotalUnit={item?.multiFamilyTotalUnit}
                      isSecondary={false}
                      MarketBlockHead={item.name}
                      images={item?.images && Object.values(item?.images)}
                      RemainShareLable='Shares remaining'
                      RemainShares={item?.sharesRemaining}
                      EstimatedDividendYieLable='Estimated Dividend Yield'
                      EstimatedDividendYield={item?.dividendYield}
                      ShareInvestorLabel='Investors'
                      ShareInvestor={item?.investors}
                      isBuyDisabled={
                        item?.percentageFunded >= 100 ||
                        maxShareCalculatorWithNoOfShare(Number(item.totalShares), 0, Number(item.userPurchasedShares)) < 1
                      }
                      duration={item.duration}
                      PrimaryButtonBuy={PRIMARY_BUTTON_BUY.includes(item?.label) && 'Buy now'}
                      GhostNotify={GHOST_NOTIFY.includes(item?.label) && 'Notify me'}
                      ProgressPercent={item?.percentageFunded?.toString()}
                      LocationProperty={`${item?.city}, ${item?.state}`}
                      RentFamily={item?.state}
                      isFavorite={item?.likedByUser}
                      MinimumnSharesLabel={PRIMARY_PROPERTY_LABELS.SHARE_PRICE}
                      MinimumnShares={`${'$' + item?.perSharePrice}`}
                      notifyLoadingId={notifyLoadingId}
                      BtnClick={() => {
                        setQuickBuyPropertyData(item);
                        setOpenQuickBuy('StepOne');
                      }}
                      notifyMeBtnClick={(value) => {
                        Object.keys(userProfileData).length ? handleNotifyMe(value) : setStoreNotifyMeData(value) || setOpen(true);
                      }}
                      propertyType={item?.propertyType}
                      propertyTypeImage={item?.propertyTypeImage}
                      onFavoriteClick={() => handleOnFavoriteClickWeb(item?.id)}
                    />
                  </Col>
                ))}
              </Row>
              <VisibilitySensor
                onChange={(value) => {
                  filterOptions?.handleInfiniteScrollWeb(value, propertyListWebData, false);
                }}
              >
                <div className='agreement__modal__dot'>.</div>
              </VisibilitySensor>
            </div>
          )}
        </div>
        <MarketFooter />
      </Spin>
      {propertyListWebData?.data?.properties?.length <= 0 && (
        <NoSearchResult
          isSecondary={false}
          title='No properties match your filter or search criteria.'
          description='Try adjusting your filters or expanding your search to see more results.'
          filterText='Try removing some other filters to see more results.'
          handleRemoveLeverage={() => filterOptions?.handleRemoveLeverage(false)}
          handleRemoveLocationFilter={() => filterOptions?.handleRemoveLocationFilter(false)}
          handleClearAll={() => filterOptions?.handleResetAllFilters(false)}
        />
      )}
      <NotifyMeModal
        open={open}
        setOpen={setOpen}
        email={email}
        setEmail={setEmail}
        newsLetterChecked={newsLetterChecked}
        setNewsLetterChecked={setNewsLetterChecked}
        handleNotifyMe={handleNotifyMe}
        ref={formRef}
      />
    </div>
  );
};

export default MarketplaceInitial;
